export const breakpoints = {
  xs: 0,
  sm: 360,
  md: 393,
  lg: 768,
  xl: 1024,
};

export const breakpointQueries = {
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
};
